import {Record} from 'immutable';
import {PRODUCTION} from 'utils/env';
import CharacterSet from './CharacterSet';
import Icon from './Icon';
import IconSet from './IconSet';
import IconSettings from './IconSettings';
import Kit from './Kit';
import WorkingSet from './WorkingSet';
import Publication from './Publication';
import KitMessage from './KitMessage';
import Subscription from './Subscription';
import JobStatusTopic from './JobStatusTopic';
import Typeface from './Typeface';
import TypefaceSettings from './TypefaceSettings';
import WorkingSetArchive from './WorkingSetArchive';
import WorkingSetIcon from './WorkingSetIcon';
import WorkingSetTypeface from './WorkingSetTypeface';
import WorkingSetImage from './WorkingSetImage';

const recordsForType = {};

const NullRecord = Record();

export const registry = {
  add(type, record) {
    recordsForType[type] = record;

    return registry;
  },

  find(type) {
    const record = recordsForType[type];

    if (!PRODUCTION && !record) {
      console.warn(`Could not find record for ${type}`);
    }

    return record || NullRecord;
  },

  typeFor(record) {
    return Object.keys(recordsForType).find((key) => {
      return record === recordsForType[key] || record instanceof recordsForType[key];
    });
  },
};

registry.add('character-sets', CharacterSet);
registry.add('icons', Icon);
registry.add('icon-sets', IconSet);
registry.add('icon-settings', IconSettings);
registry.add('kits', Kit);
registry.add('working-sets', WorkingSet);
registry.add('publications', Publication);
registry.add('kit-messages', KitMessage);
registry.add('subscriptions', Subscription);
registry.add('job-status-topics', JobStatusTopic);
registry.add('typefaces', Typeface);
registry.add('typeface-settings', TypefaceSettings);
registry.add('working-set-archives', WorkingSetArchive);
registry.add('working-set-icons', WorkingSetIcon);
registry.add('working-set-typefaces', WorkingSetTypeface);
registry.add('working-set-images', WorkingSetImage);



// WEBPACK FOOTER //
// ./app/javascript/records/index.js